export default __webpack_public_path__ + "static/media/EM1980.34I-43320_-26031_0.9c89a6be.jpg";